declare global {
  interface Window {
    __prosperoReactMounted?: boolean;
    Sentry?: {
      captureException?: (e: unknown) => void;
    };
  }
}

export function renderFallbackDom(error: unknown): void {
  const lang = (navigator.language || 'it').toLowerCase().startsWith('en') ? 'en' : 'it';

  const title = lang === 'en' ? 'Startup error' : 'Errore di avvio';
  const body =
    lang === 'en'
      ? 'An error occurred while starting the app. Reload the page to try again.'
      : "Si è verificato un problema durante l'avvio dell'app. Ricarica la pagina per riprovare.";
  const buttonLabel = lang === 'en' ? 'Reload' : 'Ricarica';

  document.body.style.backgroundColor = '#ffffff';
  document.title = 'Prospero — errore di avvio';

  const wrapper = document.createElement('div');
  wrapper.style.cssText =
    'position:fixed;inset:0;background:#ffffff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;padding:24px;font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;color:#0F172A;';

  // Inline SVG warning icon
  const svgNS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('width', '64');
  svg.setAttribute('height', '64');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', '#0F172A');
  svg.setAttribute('stroke-width', '1.5');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');

  const triangle = document.createElementNS(svgNS, 'path');
  triangle.setAttribute(
    'd',
    'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z',
  );
  svg.appendChild(triangle);

  const lineV = document.createElementNS(svgNS, 'line');
  lineV.setAttribute('x1', '12');
  lineV.setAttribute('y1', '9');
  lineV.setAttribute('x2', '12');
  lineV.setAttribute('y2', '13');
  svg.appendChild(lineV);

  const lineH = document.createElementNS(svgNS, 'line');
  lineH.setAttribute('x1', '12');
  lineH.setAttribute('y1', '17');
  lineH.setAttribute('x2', '12.01');
  lineH.setAttribute('y2', '17');
  svg.appendChild(lineH);

  wrapper.appendChild(svg);

  const h1 = document.createElement('h1');
  h1.style.cssText = 'font-size:18px;font-weight:600;margin:0;';
  h1.textContent = title;
  wrapper.appendChild(h1);

  const p = document.createElement('p');
  p.style.cssText = 'font-size:14px;color:#475569;margin:0;max-width:480px;text-align:center;';
  p.textContent = body;
  wrapper.appendChild(p);

  const button = document.createElement('button');
  button.style.cssText =
    'border-radius:8px;padding:10px 20px;background:#0F172A;color:#ffffff;border:none;cursor:pointer;font-size:14px;';
  button.textContent = buttonLabel;
  button.addEventListener('click', () => {
    window.location.reload();
  });
  wrapper.appendChild(button);

  // Local-only debug info
  if (window.location.hostname === 'localhost') {
    const message =
      error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : JSON.stringify(error);
    const pre = document.createElement('pre');
    pre.style.cssText =
      'font-size:12px;color:#94a3b8;font-family:ui-monospace,monospace;max-width:480px;overflow:auto;';
    pre.textContent = message;
    wrapper.appendChild(pre);
  }

  const root = document.getElementById('root');
  if (root) {
    root.appendChild(wrapper);
  } else {
    document.body.appendChild(wrapper);
  }
}
